import BaseComponent from '../../../../common/js/BaseComponent';

export default class SearchTable extends BaseComponent {
    searchModalElement: HTMLElement | null;

    inputElement: HTMLElement | null;

    boundSearchEventHandler: any;

    protected initSearchVar() {
        this.searchModalElement = document.getElementById('search');
        this.inputElement = document.getElementById('keyword');
    }

    init(): any {
        this.initSearchVar();
        this.onSearchModalShown();
    }

    onSearchModalShown() {
        if (this.searchModalElement) {
            this.searchModalElement.addEventListener('click', () => {
                this.search();
            });
        }
        if (this.inputElement) {
            this.inputElement.addEventListener('keyup', () => {
                this.search();
            });
        }
    }

    search() {
        const keyword = $('#keyword').val();

        $.ajax({
            url: $('#search').data('url'),
            method: 'GET',
            data: {
                keyword,
            },
        })
            .done((data) => {
                if (data) {
                    $('#content-table').html(data);
                }
            });
    }
}
